/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { CioExportButtonArgs } from 'cio/components/cio-export-button/button';
import { CioExportModalArgs } from 'cio/components/cio-export-button/export-modal';

type Args = CioExportModalArgs & CioExportButtonArgs & { useExportCSVModal: boolean };

export default class CioExportButton extends Component<Args> {
  @tracked showExportCSVModal = false;

  get useExportCSVModal() {
    return this.args.useExportCSVModal ?? false;
  }

  get buttonText() {
    return this.args.buttonText ?? 'Export to CSV';
  }
}
